module.exports = __webpack_public_path__ + "static/media/02.ab7662de.jpg";